/** Shared consent wording — shown on every form and stored with each submission. */
export const CONTACT_CONSENT_TEXT =
  "I agree to be contacted about my request and have reviewed the privacy information.";

export const SMS_CONSENT_TEXT =
  "I agree that Coastal Energy and Lawrence Williams may call and text me at the number I provided, " +
  "including with automated technology and AI-generated or prerecorded voices, about solar, battery and " +
  "energy services. Consent is not a condition of purchase. Message and data rates may apply. Reply STOP to opt out of texts.";

export const OFFICES = [
  { city: "Fort Myers", address: "12220 ITEC Haul Dr Ste 220, Fort Myers, FL 33913", maps: "https://maps.google.com/?cid=4598620663948088609" },
  { city: "Naples", address: "5660 Strand Ct A209, Naples, FL 34110", maps: "https://maps.google.com/?cid=3950224689816219215" },
  { city: "Miami", address: "7927 NW 67th St, Miami, FL 33166", maps: "https://maps.google.com/?cid=11199970517268505348" },
];

export const OFFICE_CONTACT_LINE = "Lawrence Williams, Commercial & Residential Solar — Call or text 310-881-5155";
